export default __webpack_public_path__ + "static/media/zoom-in.fc90db2c.svg";